import './home.scss';

import React from 'react';

export default function Home() {
    return (
        <React.Fragment>
            <div className='home-page-container'>
                <h1 className='home-title'>Hyper-Timesheet</h1>
                <div className='home-details'>
                    <p>
                        Portale per il caricamento tempi su commessa, timbrature, caricamento richieste ferie/permessi, approvazioni e tanto altro.
                    </p>
                    <p>
                        Utilizzare il menu in alto a sinistra per accedere alle varie funzionalità del portale
                    </p>
                </div>
            </div>
        </React.Fragment>
    )
}
